






import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Avatar extends Vue {
  @Prop({ default: 28 })
  size!: number | string

  @Prop({ default: '' })
  src!: string

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }
}
